import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/legal';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bone font-manrope flex flex-col">
      {/* Navigation */}
      <nav className="max-w-7xl mx-auto w-full px-6 md:px-12 py-6">
        <div className="flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-slate hover:text-navy transition-colors"
            data-testid="impressum-back-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm font-medium">Zurück</span>
          </button>
          <div className="font-playfair text-xl font-bold text-navy">Nico Helfrich</div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-1 max-w-4xl mx-auto w-full px-6 md:px-12 py-12">
        <h1 className="font-playfair text-4xl md:text-5xl font-bold text-navy mb-8 tracking-tight">
          Impressum
        </h1>
        
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-black/5 shadow-sm">
          <div className="space-y-8 text-charcoal">
            
            {/* Section 1: TMG */}
            <section>
              <h2 className="font-outfit text-xl font-bold text-navy mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <div className="space-y-1 leading-relaxed">
                <p className="font-medium">Nico Helfrich</p>
                <p>Strategie und Finanzstruktur</p>
                <p>Freiherr-vom-Stein-Straße 5</p>
                <p>68642 Bürstadt</p>
                <p>Deutschland</p>
              </div>
            </section>

            {/* Section 2: Contact */}
            <section>
              <h2 className="font-outfit text-xl font-bold text-navy mb-4">
                Kontakt
              </h2>
              <div className="space-y-1 leading-relaxed">
                <p>E-Mail: nico.helfrich@koenigswege.com</p>
              </div>
            </section>
              
              {/*
            
            <section>
              <h2 className="font-outfit text-xl font-bold text-navy mb-4">
                Umsatzsteuer-ID
              </h2>
              <p className="leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                DE 123 456 789 (Platzhalter - bitte ersetzen)
              </p>
            </section>
              */}

            {/* Section 4: Professional Info */}
            <section>
              <h2 className="font-outfit text-xl font-bold text-navy mb-4">
                Berufsbezeichnung und berufsrechtliche Regelungen
              </h2>
              <div className="space-y-2 leading-relaxed">
                <p>
                  <span className="font-medium">Berufsbezeichnung:</span> Versicherungsmakler mit Erlaubnis nach § 34d Abs. 1 der Gewerbeordnung
                </p>
                <p>
                  <span className="font-medium">Zuständige Aufsichtsbehörde:</span> Industrie- und Handelskammer Rhein-Neckar
                </p>
                <p>
                  <span className="font-medium">Zulassungsland:</span> Deutschland
                </p>
              </div>
            </section>

            {/* Section 5: Liability Content */}
            <section>
              <h2 className="font-outfit text-xl font-bold text-navy mb-4">
                Haftung für Inhalte
              </h2>
              <p className="leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                Tätigkeit hinweisen.
              </p>
              <p className="leading-relaxed mt-3">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
                erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte 
                umgehend entfernen.
              </p>
            </section>

            {/* Section 6: Liability Links */}
            <section>
              <h2 className="font-outfit text-xl font-bold text-navy mb-4">
                Haftung für Links
              </h2>
              <p className="leading-relaxed">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
                der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung 
                auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
                Verlinkung nicht erkennbar.
              </p>
              <p className="leading-relaxed mt-3">
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
                Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </section>

            {/* Section 7: Copyright */}
            <section>
              <h2 className="font-outfit text-xl font-bold text-navy mb-4">
                Urheberrecht
              </h2>
              <p className="leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite 
                sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
              <p className="leading-relaxed mt-3">
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
                gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, 
                bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
                werden wir derartige Inhalte umgehend entfernen.
              </p>
            </section>

            {/* Section 8: Disclaimer */}
            <section>
              <h2 className="font-outfit text-xl font-bold text-navy mb-4">
                Haftungsausschluss für Finanzberechnungen
              </h2>
              <p className="leading-relaxed">
                Die auf dieser Website bereitgestellten Finanzberechnungen, Simulationen und 
                Szenarien dienen ausschließlich zu Informationszwecken und stellen keine 
                Anlageberatung, Steuerberatung oder Rechtsberatung dar. Alle Berechnungen 
                basieren auf vereinfachten Annahmen und historischen Durchschnittswerten.
              </p>
              <p className="leading-relaxed mt-3">
                Die tatsächlichen Ergebnisse können erheblich von den simulierten Szenarien 
                abweichen. Für individuelle Finanzentscheidungen empfehlen wir die Konsultation 
                eines qualifizierten Finanzberaters. Der Betreiber dieser Website übernimmt 
                keine Haftung für Entscheidungen, die auf Grundlage der hier bereitgestellten 
                Informationen getroffen werden.
              </p>
            </section>

          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer variant="light" />
    </div>
  );
};

export default Impressum;
